{
  "dashboard": {
    "exportPDF": "Exporter au format PDF",
    "yourFacilities": "Vos installations",
    "companyPageLink": "Aller à la page Compagnie",
    "kwhConsumed": "kWh consommés",
    "energyConsumption": "Consommation d'énergie utilisée pour les rapports",
    "mtCo2eDisplaced": "MT CO2e déplacés",
    "equalToCreditsGeneratedToDate": "Égal aux crédits générés à ce jour",
    "totalNetRevenueToDate": "Revenu net total à ce jour",
    "valueOfCreditsTransacted": "Valeur des crédits échangés",
    "avgCostPerKwh": "Moy. $/kWh",
    "enrolledVehiclesAndEquipment": "Véhicules et équipement inscrits",
    "totalNumberOfAssetsProducingCredits": "Nombre total d'actifs produisant des crédits",
    "daysToNextCreditMinting": "Jours avant le prochain forgeage de crédits",
    "periodIncentiveRevenue": "Période de revenu incitatif",
    "cumulativeEnrollmentTrends": "Tendances cumulées des inscriptions",
    "revenueBreakdown": "Ventilation des revenus",
    "byEquipmentType": "Par type d'équipement",
    "byProgram": "Par programme",
    "equipmentTypeByFacility": "Type d'équipement par installation",
    "currentFacilityLocations": "Emplacements actuels des installations",
    "percentRevenueByEquipmenttype": "Pourcentage de revenu par type d'équipement",
    "percentRevenueByProgram": "Pourcentage de revenu par programme"
  }
}
